export const MODAL_TYPES = {
  ACADEMY: "Academy",
  DOMAIN: "Domain",
  SKILLPATH: "SkillPath",
  CONTENT: "Content",
};
